
    <div class="wrapper">
        <div class="container px-0">
            <h5 class="main-title">Madison Medical & Sports</h5>
            <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
            <div class="main-info">
                <strong>Reason of Visit</strong> 
               </div>
            <div  class="form-row">
                <div class="col-md-4">
                    <div class="form-group">
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control"  [(ngModel)]= "patientintakedata.isPatientInjured">
                          <option value="Yes" disabled selected>Yes</option>
                          <!-- <option value="No">No</option> -->
                        </select>
                        <label >Injured</label>
                      </div>
                    </div>
                  </div>
                    
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control" [(ngModel)]= "patientintakedata.workerComp" >
                            <option value="" disabled selected>Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <label >Worker Comp.</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label >What was your injury?</label> -->
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control" [(ngModel)]= "patientintakedata.injuryDesccription" >
                          <option value="" disabled selected>Select</option>
                          <option value="Back Injury" >Back Injury</option>
                          <option value="Neck Injury">Neck Injury</option>
                          <option value="Hip Injury">Hip Injury</option>
                          <option value="Knee Injury">Knee Injury</option>
                          <option value="Ankle/Foot Injury">Ankle/Foot Injury</option>
                          <option value="Shoulder Injury">Shoulder Injury</option>
                          <option value="Elbow Injury">Elbow Injury</option>
                          <option value="Wrist/Hand Injury">Wrist/Hand Injury</option>
                          <option value="Head Injury">Head Injury</option>
                        </select>
                        <label >What was your injury?</label>

                      </div>
                    </div>
                  </div>


                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label >Have you seen anyone else for this injury?</label> -->
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control"  (change)="CheckType($event.target,'provider')" >
                            <option value="" disabled selected>Select</option>
                          <option value="Yes" >Yes</option>
                          <option value="No">No</option>
                        </select>
                        <label >Have you seen anyone else for this injury?</label>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="IsproviderName" class="col-md-4">
                    <div class="form-group ">
                      <div class="form-group form-floating">
                        <input type="text" class="form-control" placeholder="Type here" [(ngModel)]= "patientintakedata.providerName"  >
                        <label>Provider Name</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label >Do you have an MRI,X-ray or Blood work done?</label> -->
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control" (change)="CheckType($event.target,'facility')" >
                          <option value="" disabled selected>Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <label >Do you have an MRI,X-ray or Blood work done?</label>
                      </div>
                    </div>
                  </div>


                  <div *ngIf="IsfacName" class="col-md-4">
                    <div class="form-group ">
                      <div class="form-group form-floating">
                        <input type="text" class="form-control" placeholder="Type here" [(ngModel)]= "patientintakedata.facilityName">
                        <label>Facility Name </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label >Do you have a primary care physician?</label> --> 
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control" (change)="CheckType($event.target,'physician')" >
                          <option value="" disabled selected>Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <label >Do you have a primary care physician?</label>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="IsphyName" class="col-md-4">
                    <div class="form-group ">
                      <div class="form-group form-floating">
                        <input type="text" class="form-control" placeholder="Type here" [(ngModel)]= "patientintakedata.lastPhysicianName">
                        <label>Name of last physician </label>
                      </div>
                    </div>
                  </div>
                

                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label>When was your last physical?</label> -->
                      <div class="position-relative form-floating">
                        <input type="date" class="form-control" value="4/23/1998" placeholder="MM/DD/YYYY" (focusout)="focusOutFunction($event.target, 'physical')" max="{{curDate | date:'yyyy-MM-dd'}}"/> 
                        <label>When was your last physical?</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label>When was your last set of full blood work?</label> -->
                      <div class="position-relative form-floating">
                        <input type="date" class="form-control" value="4/23/1998" placeholder="MM/DD/YYYY" (focusout)="focusOutFunction($event.target, 'blood')" max="{{curDate | date:'yyyy-MM-dd'}}"/> 
                        <label>When was your last set of full blood work?</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                        <!-- <label > If schedling with PT, do you have a PT Script?</label> -->
                      <div class="form-select form-floating">
                        <select translate="no" class="form-control" (change)="CheckType($event.target,'script')" >
                          <option value="" disabled selected>Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        <label > If scheduling with PT, do you have a PT Script?</label>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="Isscript" class="col-md-4">
                    <div class="form-group ">
                      <div class="form-group form-floating">
                        <input type="text" class="form-control" placeholder="Type here"  [(ngModel)]= "patientintakedata.referringDoctor">
                        <label>Referring Doctor? </label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="position-relative form-floating">
                        <input type="date" class="form-control" value="4/23/1998" placeholder="MM/DD/YYYY" (focusout)="focusOutFunction($event.target, 'rxdate')" max="{{curDate | date:'yyyy-MM-dd'}}"/> 
                        <label>Date of RX</label>
                      </div>
                    </div>
                  </div>
            </div>

        </div>
    </div>
    <footer class="p-3">
        <div class="container p-0">
            <div class="text-right">
                <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#ConsentForm1" >Next</button> -->
                  <button type="button" class="btn btn-primary" data-toggle="modal" (click)= "sendPatInfo()">Next</button>
            </div>
        </div>
    </footer>
